import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.553 22.776A.5.5 0 0 1 6 22.5h6.95a.5.5 0 0 1 0 1H6.309l-3.5 7h26.382l-3.5-7H19.05a.5.5 0 0 1 0-1H26a.5.5 0 0 1 .447.276l4 8A.5.5 0 0 1 30 31.5H2a.5.5 0 0 1-.447-.724z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.247 3.297A9.55 9.55 0 0 1 25.55 10.05c0 4.242-2.346 8.39-4.625 11.431a39 39 0 0 1-4.192 4.722 22 22 0 0 1-.373.346l-.02.018-.006.006-.003.001L16 26.2c-.331.375-.331.375-.332.374l-.002-.002-.005-.005-.021-.018-.079-.072-.294-.274a39.203 39.203 0 0 1-4.192-4.722C8.795 18.44 6.45 14.292 6.45 10.05a9.55 9.55 0 0 1 2.797-6.753M16 26.2l-.332.374c.19.167.474.167.663 0zm0-.68.045-.043c.243-.23.59-.569 1.01-1.002a38 38 0 0 0 3.07-3.594c2.245-2.996 4.425-6.923 4.425-10.831a8.55 8.55 0 1 0-17.1 0c0 3.908 2.18 7.835 4.425 10.831a38 38 0 0 0 4.08 4.596z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			d: "M16 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0",
			clipRule: "evenodd"
		})
	]
});
export default SvgIconLocation;
